<template>
<div >
    <v-toolbar flat color="white">
        <v-btn id="contactTypeAddButtonId" color="primary" dark class="mb-2" @click="newDialog=true" round >ADD TYPE</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD TYPE</h1>
        </v-toolbar>


          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    id="contactTypeAddNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="Name*"
                    hint="what would you like to call this type"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn id="contactTypeSaveAddButtonId" color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT TYPE</h1>
        </v-toolbar>


          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    id="contactTypeEditNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="Name*"
                    hint="what would you like to call this type"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
     
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn id="contactTypeSaveEditButtonId" color="blue darken-1" flat @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
       :loading="isLoading"
      :items="contactTypes"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon id="contactTypeEditButtonId" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon id="contactTypeDeleteButtonId" small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>

          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
    showDetails: true,
    loading: false, 
     isLoading: true,
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
    ],
    contactTypes: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
        name: "",
      
        isActive: true,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
        search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.contactTypes= await this.searchContactTypes(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/contactTypes'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  methods: {
     searchContactTypes(search){
        this.isLoading=true  
      if(search.search!==""){      
        Api()
        .get('/contactTypes',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.contactTypes=response.data
           this.isLoading=false  
        })} 
      },
    fetchContactTypes() {
      this.isLoading=true
      Api()
        .get("/contactTypes/active")
        .then(response => {
          this.contactTypes = response.data;
          this.isLoading=false
        });
      
    },
    initialize() {
      this.fetchContactTypes();
    },
    editItem(item) {
      this.editedIndex = this.contactTypes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
      deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/contactTypes/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
          this.fetchContactTypes()
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       let proceed=true
        if(this.editedItem.name == ""){
          proceed =false
          confirm('Please fill in a name.')
        }
         if (proceed ==true ) {
        Api().put("/contactTypes/" + this.editedItem.id, {
          name: this.editedItem.name,
          
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive
        }).then(response => {
          this.fetchContactTypes()
        })
        this.close();
        Object.assign(this.contactTypes[this.editedIndex], this.editedItem);
      }},
      saveNew() {
         let proceed=true
        if(this.editedItem.name == ""){
          proceed =false
          confirm('Please fill in a name.')
        }
         if (proceed ==true ) {
        Api().post("/contactTypes", {
          name: this.editedItem.name,
          
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive     
        }).then(response => {
          this.fetchContactTypes()
        })
        this.close();
    }
      }
  }
};
</script>